import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Divider, Input, Space } from 'antd';
import { IoPrintOutline } from "react-icons/io5";
import { GiPayMoney } from 'react-icons/gi';
import { BsSendFill } from "react-icons/bs";
import { IoIosArrowDropleftCircle, IoIosArrowDroprightCircle } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import PosSessionContext from '../utils/PosSessionContext';
import { getOrderTotal, getTaxOrderTotal } from '../utils/usePosSessionReducer';
import formatAmount from '../../utils/formatAmount';
import GHSymbol from '../../globalComponents/GHSymbol';
// import posreceipt from '../utils/posreceipt';




const PosOrderReprintPage = () => {
  const navigate = useNavigate();
  const { order, cashier, user } = useContext(PosSessionContext);
  const printRef = useRef();
  const [pos, setPos] = useState({});
 
  const goBack = () => navigate(-1);

  useEffect(() => {
    let pos_ = localStorage.getItem('caspian_pos');
    pos_ = JSON.parse(pos_);
    setPos(pos_);
  },[])

  const handlePrint = () => {
    
    const originalContents = document.body.innerHTML; // Save original page content
    const printContents = printRef.current.innerHTML; // Get only the printable content
    
    // Replace the page's HTML with only the printable section
    document.body.innerHTML = printContents;

    // Print the page
    window.print();

    // Restore original content after printing
    document.body.innerHTML = originalContents;
    window.location.reload(); // Reload to restore any lost JavaScript context
    
  };

  // console.log(typeof(getTaxOrderTotal(order.orderlines)))

  return (
    <div className='container mx-auto' style={{maxWidth: '1200px'}}>
      <div className='bg-white shadow w-full' style={{minHeight: 'inherit'}}>
        <div className='flex p-3'>
          <div className='w-2/3'>
            <div style={{width: '95%'}}>
              <div className='flex items-center' style={{height: '200px'}}><h3 className='font-semibold text-lg'>How would you like to receive your receipt and invoice?</h3></div>
              <div className='w-full'><Button type='primary' onClick={handlePrint} className='w-full h-10 font-semibold' icon={<IoPrintOutline />}>Print Receipt</Button></div>
              <div className='mt-3'>
                <Space.Compact className='w-full border '>
                  <Input 
                    type='text'
                    className='input-outline-none p-0 px-2'
                    placeholder='johndoe@example.com'
                  />
                  <div className='bg-[#05bcc4] h-full'>
                  <Button type="text" icon={<BsSendFill />} className='font-semibold rounded-none w-40 h-full hover:rounded-none'>Send</Button>
                  </div>
                </Space.Compact>
              </div>
            </div>
          </div>
          <div ref={printRef} className='border print:block ' style={{width: '40%', maxHeight: '540px'}}>
            <div id='printable-section'  className='p-1 overflow-y overflow-y-scroll' style={{maxHeight: 'inherit'}}>
              <div className='flex justify-center'>
                <img src='https://www.casspian.com/uploads/caspian_logo.png' alt='caspian logo' width={70} />
              </div>
              <div className='flex flex-col items-center mb-2'>
                <h1 style={{fontSize: '14px'}}>Caspian Outlets Limited</h1>
                <div className='flex'>
                  <h2 className='me-1'>{pos?.name}</h2> |
                  <p className='mx-1'>{pos?.hotline}</p> |
                  <p className='ms-1'>www.casspian.com</p>
                </div>
                <Divider variant='dashed' className='py-0 my-2' style={{width: '50px', backgroundColor: 'black'}}/>
                <p className='mb-3'>Served by <span>{cashier.name}</span></p>
                <h3 className='text-center'>Receipient: {order.cus_name} | <span>{order.cus_phone}</span></h3>
                {/* <p>Phone: <span>+233123456789</span></p> */}
              </div>
              <div>
                <table className=''>
                  <thead className='border-y-2 border-dashed border-black mb-2'>
                    <tr>
                      <th className='w-1/5 text-start'>Qty</th>
                      <th className='w-3/5 text-start'>Description</th>
                      <th className='w-3/5 text-end'>
                        <span className='block'>Amount</span>
                        <span className='block'>(<GHSymbol />)</span>
                      </th>
                    </tr>
                  </thead> 
                  <tbody className='border-b-2 border-dashed border-black mb-3'>
                    {order.orderlines.map((line, id) => 
                      <>
                      <tr key={id}>
                        <td style={{marginBottom: '12px'}}><span>{order.is_refund ? line.quantity * -1 : line.quantity * 1}</span></td>
                        <td className='uppercase w-full'>
                          <p className='mb-0'>{line.name} </p>
                          <span className='text-xs font-semibold'>{order.is_refund ? line.sales_price * -1 : line.sales_price}</span>
                        </td>
                        <td className='text-end'>{order.is_refund ? formatAmount((line.sales_price * -1) * (line.quantity * 1)) : formatAmount(line.sales_price * (line.quantity * 1))}</td>
                      </tr>
                      </>
                    )}
                  </tbody>
                  <tfoot className='receipt-footer'>
                  <tr>
                      <td></td>
                      <td className='pt-2 text-lg'>TOTAL</td>
                      {/* <td rowSpan={1} className='text-end font-semibold text-nowrap pt-2'>{order.is_refund ? formatAmount(getOrderTotal(order.orderlines) * -1) : formatAmount(getOrderTotal(order.orderlines)*1)}</td> */}
                      <td className='text-lg text-end font-semibold text-nowrap'>
                      {order.is_refund ? formatAmount(getOrderTotal(order.orderlines) * -1 + getTaxOrderTotal(order.orderlines)*-1) : formatAmount(getOrderTotal(order.orderlines)*1 + getTaxOrderTotal(order.orderlines))}  
                      </td>
                    </tr>
                    {order.paymentLines.map((line, id) => 
                      <tr key={id}>
                        <td>{line.name}</td>
                        <td> </td>
                        <td style={{fontSize: '16px'}} className='text-end font-semibold text-nowrap'>{order.is_refund ? formatAmount((line.amount * -1)) : formatAmount((line.amount * 1))}</td>
                      </tr>
                    )}
                    <tr>
                      <td></td>
                      <td className='text-lg'>CHANGE</td>
                      <td className='text-lg text-end font-semibold'>{formatAmount(order.order_change || 0)}</td>
                    </tr>
                    <tr>
                      <td>VAT 4%</td>
                      <td></td>
                      <td style={{fontSize: '16px'}} className='text-end font-semibold'>{formatAmount(order.orderlines.reduce((prev, current) => ((order.is_refund ? current.tax * -1 :current.tax* 1) + prev), 0))}</td>
                    </tr>
                    {/* <tr>
                      <td>Discount Applied</td>
                      <td></td>
                      <td className='text-end font-semibold'>{formatAmount(0)} &#8373;</td>
                    </tr> */}
                    
                    {/* <tr>
                      <td>Total</td>
                      <td></td>
                      <td className='text-end font-semibold'>
                      {order.is_refund ? formatAmount(getOrderTotal(order.orderlines) * -1 + getTaxOrderTotal(order.orderlines)*-1) : formatAmount(getOrderTotal(order.orderlines)*1 + getTaxOrderTotal(order.orderlines))}
                      </td>
                    </tr> */}
                    
                  </tfoot>
                </table>

                <div className='mb-2'>
                  <div className='flex justify-between'>
                    <p>Discount Applied</p>
                    <span style={{fontSize: '16px'}} className='text-end font-semibold'>{formatAmount(0)}</span>
                  </div>
                </div>
                {/* <div className='mb-2'>
                  <div className='flex justify-between'>
                    <p>TOTAL</p>
                    <span className='text-end font-semibold'>
                      {order.is_refund ? formatAmount(getOrderTotal(order.orderlines) * -1 + getTaxOrderTotal(order.orderlines)*-1) : formatAmount(getOrderTotal(order.orderlines)*1 + getTaxOrderTotal(order.orderlines))}
                    </span>
                  </div>
                </div> */}
                
                <div className='receipt-bottom'>
                  <div>
                    <p className='text-center'>We gladly accept returns within 10 days of purchase.</p>
                    <p>Thanks for shopping with us!</p>
                  </div>
                  <div>
                    <span >{order.receipt_number}</span>
                    <span >{new Date().toUTCString()}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='bg-[#05bcc4] h-3/4'>
          <Button type='text' onClick={goBack} className='font-semibold w-full h-full flex flex-col items-center rounded-none'>
            <IoIosArrowDropleftCircle color='black' size={'4rem'} />
            <span style={{height: '26px', color: 'white', fontSize: '18px'}}>Go Back</span>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default PosOrderReprintPage;